// extracted by mini-css-extract-plugin
export default {"pontos":"Carregando_pontos__STTTQ","pular":"Carregando_pular__KeF5T","circulo":"Carregando_circulo__grxy4","girar":"Carregando_girar__K7dDQ"};